import { render } from "./postDelete.vue?vue&type=template&id=2a8faa9d"
import script from "./postDelete.vue?vue&type=script&lang=js"
export * from "./postDelete.vue?vue&type=script&lang=js"
script.render = render

export default script